import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './i18n';
import Router from './router/Router';
import { AuthProvider } from './contexts/AuthContext';
import WhatsAppButton from './components/WhatsAppButton';

import '../node_modules/react-modal-video/css/modal-video.css';
import './assets/css/bootstrap.min.css'
import './assets/css/font-awesome.min.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/custom.css'
import './assets/vendor/themify/themify-icons.css'
import './assets/css/animate.css'
import './assets/css/style.css'


function App() {
  return (
    <>
      <HelmetProvider>
        <BrowserRouter basename='/'>
          <AuthProvider>
              <Router/>
              <WhatsAppButton />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
